import { useEffect, useState } from 'react'
import { adminAPI } from '@utils/api'

const AdminSetup = () => {
  const [checking, setChecking] = useState(true)
  const [message, setMessage] = useState('')
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    whatsapp: ''
  })

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const res = await adminAPI.getSetupStatus()
        if (!res.data.setupRequired) {
          window.location.href = '/admin/login'
          return
        }
      } catch {}
      setChecking(false)
    }
    checkStatus()
  }, [])

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await adminAPI.createFirstAdmin(form)
      localStorage.setItem('adminToken', res.data.token)
      localStorage.setItem('adminUser', JSON.stringify(res.data.admin))
      window.location.href = '/admin'
    } catch (error) {
      setMessage(error.message || 'Setup failed')
    }
  }

  if (checking) {
    return <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center dark:text-white">Loading...</div>
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="card p-8 w-full max-w-lg">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Admin Setup</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">Create the first super admin account.</p>
        <input className="input-field mb-4" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required />
        <input className="input-field mb-4" name="email" placeholder="Email" type="email" value={form.email} onChange={handleChange} required />
        <input className="input-field mb-4" name="password" placeholder="Password" type="password" value={form.password} onChange={handleChange} required />
        <input className="input-field mb-4" name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} />
        <input className="input-field mb-4" name="whatsapp" placeholder="WhatsApp" value={form.whatsapp} onChange={handleChange} />
        {message ? <div className="text-sm text-red-600 dark:text-red-400 mb-4">{message}</div> : null}
        <button className="btn btn-primary w-full">Create Admin</button>
      </form>
    </div>
  )
}

export default AdminSetup
